import { GUARANTEE_CODES, PAYMENT_CODES } from '../constants/api';


export const isPrepayRate = (code) => (PAYMENT_CODES.includes(code));
export const isFlexibleRate = (code) => (GUARANTEE_CODES.includes(code));
